import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Urbaniaforwedding() {

const cardData = {
keyword: "Urbania for Wedding Events in Pune",
headingDescription: "Urbania for Wedding Events in Pune provides spacious and convenient group transportation for wedding guests, relatives, family members, and event teams travelling between homes, hotels, marriage halls, banquet venues, and ceremony locations. Ruturaj Enterprises offers Urbania options suitable for different group sizes, including 13-seater, 14-seater, 17-seater, and 20-seater requirements. These vehicles can be arranged for wedding guest transfers, marriage functions, ceremonies, receptions, family gatherings, airport pickups, and multi-location wedding schedules across Pune and nearby areas.",
topPlaces: [
{
title: "Koregaon Park",
description: "Koregaon Park has numerous hotels, restaurants, event spaces, and premium venues that are frequently used for family celebrations and wedding-related gatherings. Urbania transportation can help move wedding guests between hotels, residences, ceremony venues, and reception locations."
},
{
title: "Kharadi",
description: "Kharadi is a major eastern Pune locality with hotels, residential communities, corporate facilities, and event spaces. Urbania vehicles can be arranged for wedding guest transportation, family functions, ceremonies, receptions, and transfers between accommodation and wedding venues."
},
{
title: "Baner",
description: "Baner is a popular western Pune area with hotels, banquet facilities, restaurants, and event venues. Wedding groups can use Urbania transportation for guest pickups, family movements, venue transfers, reception travel, and coordinated transportation throughout the function."
},
{
title: "Wakad",
description: "Wakad provides convenient connectivity between Pune and PCMC and has several hotels, residential areas, and event facilities. Urbania hire can assist wedding families with transporting guests between residences, hotels, marriage venues, and other scheduled locations."
},
{
title: "Viman Nagar",
description: "Viman Nagar is close to Pune International Airport and has several hotels and hospitality facilities. Urbania transportation is useful for collecting wedding guests arriving by air and taking them together to hotels, wedding venues, reception locations, or family functions."
},
{
title: "Hinjewadi",
description: "Hinjewadi is a major employment and residential corridor with hotels and event facilities nearby. Families organizing weddings can arrange Urbania vehicles for guests, relatives, corporate connections, and other groups travelling between accommodation and wedding functions."
},
{
title: "Hadapsar",
description: "Hadapsar is an important eastern Pune residential and commercial area with access to Magarpatta and nearby event locations. Urbania can be arranged for wedding guest transfers, family gatherings, marriage ceremonies, receptions, and transportation between multiple wedding venues."
},
{
title: "Kothrud",
description: "Kothrud is a major residential area in western Pune with strong connectivity to central and western parts of the city. Wedding families can use Urbania vehicles to transport relatives and guests between homes, hotels, marriage halls, ceremony venues, and reception locations."
},
{
title: "Pimpri Chinchwad",
description: "Pimpri Chinchwad has numerous residential areas, hotels, banquet halls, and event facilities suitable for wedding functions. Urbania transportation can accommodate groups travelling from PCMC toward Pune venues or between different wedding-related locations."
},
{
title: "Pune International Airport",
description: "Pune International Airport is an important arrival point for relatives and guests attending weddings from other cities. A spacious Urbania can collect multiple guests together with luggage and transfer them to hotels, residences, ceremony venues, or reception locations."
}
],
services: [
{
name: "Urbania on Rent for Wedding Events Pune",
description: "Urbania on Rent for Wedding Events Pune provides spacious group transportation for relatives, friends, guests, and family members attending wedding functions. Vehicles can be arranged for transfers between homes, hotels, marriage halls, ceremony venues, and reception locations."
},
{
name: "Urbania Traveller for Wedding Pune",
description: "Urbania Traveller for Wedding Pune is suitable for families and guest groups requiring comfortable transportation during different stages of a wedding. It can be used for guest pickups, venue transfers, reception travel, family functions, and related wedding activities."
},
{
name: "Urbania Hire for Wedding Guests Pune",
description: "Urbania Hire for Wedding Guests Pune helps families coordinate transportation for multiple guests travelling together. It can be arranged between hotels, residences, banquet halls, marriage venues, reception locations, and other points included in the wedding itinerary."
},
{
name: "Luxury Urbania on Rent for Wedding Pune",
description: "Luxury Urbania on Rent for Wedding Pune offers a premium group transportation option for special wedding occasions. It can be used for close family members, important guests, wedding parties, hotel transfers, venue movements, and longer journeys associated with the celebration."
},
{
name: "13 Seater Urbania for Wedding Pune",
description: "13 Seater Urbania for Wedding Pune is suitable for smaller wedding groups and family units travelling together. The vehicle can be arranged for guest transportation, ceremony transfers, hotel pickups, reception travel, and movement between different wedding locations."
},
{
name: "14 Seater Urbania for Wedding Pune",
description: "14 Seater Urbania for Wedding Pune provides a convenient option for medium-sized wedding groups. It can transport relatives, friends, and guests between accommodation, marriage halls, ceremony venues, reception locations, and other planned stops."
},
{
name: "17 Seater Urbania for Wedding Pune",
description: "17 Seater Urbania for Wedding Pune is useful for larger groups attending wedding functions together. It can be arranged for guest transfers, family travel, ceremony transportation, reception movements, airport pickups, and wedding-related outstation journeys."
},
{
name: "20 Seater Urbania for Wedding Pune",
description: "20 Seater Urbania for Wedding Pune is designed for larger wedding groups requiring shared transportation. It can help families move guests between hotels, residences, wedding venues, reception halls, airports, and other scheduled locations with better group coordination."
},
{
name: "Urbania Booking for Wedding Pune",
description: "Urbania Booking for Wedding Pune allows families to plan group transportation according to wedding dates, passenger capacity, pickup points, venues, and event schedules. Advance arrangements can help coordinate multiple transfers during ceremonies, receptions, and related functions."
},
{
name: "Urbania Van Rental for Wedding Pune",
description: "Urbania Van Rental for Wedding Pune provides a spacious vehicle option for wedding guests and family groups. It can be used for local Pune transfers, venue changes, hotel transportation, airport pickups, and other movements required during a wedding program."
},
{
name: "Urbania for Marriage Function Pune",
description: "Urbania for Marriage Function Pune can be arranged for transporting relatives, friends, guests, and family members to marriage halls, banquet venues, community halls, and other function locations. It is useful when several passengers need coordinated transportation."
},
{
name: "Urbania for Wedding Guest Transportation Pune",
description: "Urbania for Wedding Guest Transportation Pune helps simplify guest movement during busy wedding schedules. Dedicated vehicles can be planned for hotel pickups, residential pickups, venue transfers, reception transportation, airport arrivals, and departures after the event."
},
{
name: "Urbania for Marriage Ceremony Pune",
description: "Urbania for Marriage Ceremony Pune provides group transportation for guests attending the main wedding ceremony. It can be used to transfer family members and invitees from hotels, homes, accommodation facilities, and gathering points to the ceremony venue."
},
{
name: "Urbania Hire for Wedding Function Pune",
description: "Urbania Hire for Wedding Function Pune is suitable for transporting groups to engagement functions, marriage ceremonies, receptions, family gatherings, and other wedding events. A dedicated vehicle helps keep guests together while following the planned event schedule."
},
{
name: "Urbania for Wedding Party Pune",
description: "Urbania for Wedding Party Pune can be arranged for friends, relatives, family groups, and wedding participants travelling together. It is suitable for transfers between hotels, venues, residences, celebrations, and other locations included in the wedding itinerary."
},
{
name: "Urbania for Family Wedding Pune",
description: "Urbania for Family Wedding Pune provides a practical transportation solution for families attending or organizing wedding celebrations. Vehicles can be used for relatives, elders, children, and other family members travelling between accommodation, homes, ceremonies, and receptions."
},
{
name: "Urbania Traveller Booking for Wedding Pune",
description: "Urbania Traveller Booking for Wedding Pune helps families arrange group vehicles ahead of important wedding dates. Booking details can be planned around the number of passengers, pickup locations, venues, event timings, and the complete wedding transportation schedule."
},
{
name: "Urbania for Wedding Event Transportation Pune",
description: "Urbania for Wedding Event Transportation Pune supports organized movement throughout a wedding program, including guest pickups, ceremony transfers, reception transportation, hotel movements, airport transfers, and transportation between multiple event venues."
},
{
name: "Urbania on Rent for Marriage Pune",
description: "Urbania on Rent for Marriage Pune is suitable for families looking for shared transportation during marriage functions and related celebrations. It can be arranged for local Pune travel, guest movements, venue transfers, hotel pickups, and other planned wedding requirements."
},
{
name: "Luxury Urbania Traveller for Wedding Pune",
description: "Luxury Urbania Traveller for Wedding Pune provides a premium group transportation option for wedding families and guests. It can be used for special guest movements, hotel transfers, venue transportation, family travel, airport pickups, and other important wedding-related journeys."
}
],
tableData: [
["Urbania on Rent for Wedding Events Pune"],
["Urbania Traveller for Wedding Pune"],
["Urbania Hire for Wedding Guests Pune"],
["Luxury Urbania on Rent for Wedding Pune"],
["13 Seater Urbania for Wedding Pune"],
["14 Seater Urbania for Wedding Pune"],
["17 Seater Urbania for Wedding Pune"],
["20 Seater Urbania for Wedding Pune"],
["Urbania Booking for Wedding Pune"],
["Urbania Van Rental for Wedding Pune"],
["Urbania for Marriage Function Pune"],
["Urbania for Wedding Guest Transportation Pune"],
["Urbania for Marriage Ceremony Pune"],
["Urbania Hire for Wedding Function Pune"],
["Urbania for Wedding Party Pune"],
["Urbania for Family Wedding Pune"],
["Urbania Traveller Booking for Wedding Pune"],
["Urbania for Wedding Event Transportation Pune"],
["Urbania on Rent for Marriage Pune"],
["Luxury Urbania Traveller for Wedding Pune"]
],
whychoose: [
{
WhyChooseheading: "Dedicated Transportation for Wedding Groups",
WhyChoosedescription: "Ruturaj Enterprises provides Urbania transportation for families, relatives, friends, and wedding guests who need to travel together between multiple locations. A dedicated group vehicle makes it easier to coordinate transportation throughout a busy wedding schedule."
},
{
WhyChooseheading: "Multiple Seating Capacities",
WhyChoosedescription: "Wedding groups can vary significantly in size, so different seating options are useful for different functions. Ruturaj Enterprises can arrange requirements around 13-seater, 14-seater, 17-seater, and 20-seater Urbania options according to group size and travel needs."
},
{
WhyChooseheading: "Suitable for Multi-Venue Weddings",
WhyChoosedescription: "Many weddings involve separate locations for ceremonies, receptions, accommodation, family gatherings, and other functions. Urbania transportation can help move guests between these locations according to the planned itinerary and event timings."
},
{
WhyChooseheading: "Convenient Guest Transfers",
WhyChoosedescription: "Wedding guests arriving from different cities may need transportation between airports, railway stations, hotels, homes, and venues. A spacious Urbania can accommodate a group and their luggage while reducing the need to coordinate several separate vehicles."
},
{
WhyChooseheading: "Useful for Family and Relatives",
WhyChoosedescription: "Family weddings often involve relatives of different ages travelling together throughout several functions. Urbania vehicles provide a practical shared transportation option for family members attending ceremonies, receptions, dinners, and other wedding celebrations."
},
{
WhyChooseheading: "Comfortable for Special Events",
WhyChoosedescription: "Wedding transportation can involve several hours of movement between venues and accommodation. Suitable Urbania options provide spacious group travel for guests attending marriage ceremonies, receptions, family functions, and related celebrations across Pune."
},
{
WhyChooseheading: "Planned Booking for Important Dates",
WhyChoosedescription: "Wedding dates are generally fixed well in advance, allowing families to organize their transportation requirements early. Advance Urbania booking can help coordinate passenger numbers, pickup locations, venues, event timings, and multiple transfers."
},
{
WhyChooseheading: "Professional Driver Assistance",
WhyChoosedescription: "Professional driver assistance is useful when wedding groups need to follow a detailed itinerary across several Pune locations. Guests can concentrate on the celebration while transportation is handled according to the agreed pickup points and destinations."
}
]
};


















const faqData = [
{
question: "How can I hire an Urbania for wedding events in Pune?",
answer: "Families and wedding organizers can enquire about an Urbania by sharing the wedding venue, pickup locations, event date, guest count, reporting time, and required travel schedule. Ruturaj Enterprises can discuss the transportation arrangement for ceremonies, receptions, guest transfers, hotel movements, and other wedding-related journeys."
},
{
question: "Why is an Urbania useful for wedding transportation in Pune?",
answer: "An Urbania can be considered when several relatives or wedding guests need to travel together between different locations. It can help coordinate transportation between hotels, homes, marriage halls, reception venues, railway stations, airports, and other places included in the wedding itinerary."
},
{
question: "Can I book an Urbania to transport wedding guests in Pune?",
answer: "Wedding families can arrange an Urbania for transporting guests between their accommodation and the wedding venue. Multiple pickup points, guest count, venue timings, and return schedules can be shared with Ruturaj Enterprises to plan the group transportation according to the function schedule."
},
{
question: "Can Urbania be hired for wedding guest airport transfers in Pune?",
answer: "An Urbania can be used for group transfers between Pune Airport and hotels, residences, or wedding venues. Families can provide flight timings, passenger count, luggage requirements, pickup details, and required reporting time when arranging airport transportation for wedding guests."
},
{
question: "Can I hire an Urbania for a wedding baraat in Pune?",
answer: "Families can enquire about Urbania transportation for wedding-related group movements, including travel between the starting point and ceremony venue. The event route, passenger count, reporting time, and schedule can be discussed in advance so the vehicle arrangement matches the planned wedding program."
},
{
question: "Can an Urbania be used for multi-day wedding events in Pune?",
answer: "For weddings involving ceremonies across several days, families can discuss a multi-day Urbania rental arrangement. The schedule may include hotel transfers, venue movements, guest transportation, airport or railway station pickups, and travel between different function locations."
},
{
question: "Can wedding organizers hire an Urbania for outstation guests coming to Pune?",
answer: "Wedding organizers can enquire about Urbania transportation for guests arriving from nearby cities or other destinations. The vehicle can be planned for transfers between Pune Airport, railway stations, hotels, wedding venues, and other scheduled locations depending on the guest itinerary."
},
{
question: "Can families use an Urbania for wedding-related sightseeing in Pune?",
answer: "Families with guests visiting Pune for a wedding can also consider an Urbania for sightseeing or local group tours before or after the functions. The planned attractions, hotel pickup points, passenger count, travel duration, and return location can be shared while arranging the vehicle."
},
{
question: "Can Urbania rental cover transportation between hotels and wedding venues?",
answer: "An Urbania can be arranged for scheduled hotel-to-venue and venue-to-hotel transfers when multiple wedding guests are staying at the same or nearby accommodations. Ruturaj Enterprises can review the pickup points, function timings, number of passengers, and return schedule provided by the wedding organizers."
},
{
question: "What details are required to book an Urbania for a wedding in Pune?",
answer: "Families can provide the wedding dates, venue addresses, guest count, hotel locations, pickup points, reporting times, number of functions, and expected rental duration. Details about airport transfers, railway station pickups, multiple venues, guest movements, and outstation travel can also be shared with Ruturaj Enterprises."
}
];

const testimonials = [
{
id: 1,
name: "Mr. Sachin Patil",
feedback:
"For my cousin's wedding in Pune, several relatives were staying at different hotels and needed transportation to the venue for multiple functions. We hired an Urbania from Ruturaj Enterprises and shared the event schedule in advance. Having a dedicated group vehicle made the guest movements much easier to organize.",
rating: 5
},
{
id: 2,
name: "Miss. Radhika Deshmukh",
feedback:
"Our family had guests arriving from Mumbai and other cities for a two-day wedding celebration. Ruturaj Enterprises arranged an Urbania for airport and hotel transfers as well as travel to the wedding venue. The group could travel together, which made the transportation arrangements much simpler for everyone involved.",
rating: 5
}
];





































    const Images = [
        { place: "/images/keyword/1.jpg", text: "Tempo Traveller On Rent in Pune", link: "Tempo-Traveller-On-Rent-in-Pune" },
        { place: "/images/keyword/2.jpg", text: "Pune to Shirdi Tempo Traveller on Rent", link: "Pune-to-Shirdi-Tempo-Traveller-on-Rent" },
        { place: "/images/keyword/3.jpg", text: "Pune to Mahabaleshwar Tempo Traveller on Rent", link: "Pune-to-Mahabaleshwar-Tempo-Traveller-on-Rent" },
        { place: "/images/keyword/4.jpg", text: "Pune to Goa Tempo Traveller", link: "Pune-to-Goa-Tempo-Traveller" },
        { place: "/images/keyword/5.jpg", text: "Pune to Mumbai Tempo Traveller on Rent", link: "Pune-to-Mumbai-Tempo-Traveller-on-Rent" },
        { place: "/images/keyword/6.jpg", text: "Pune to Konkan Tempo Traveller", link: "Pune-to-Konkan-Tempo-Traveller" },
        { place: "/images/keyword/7.jpg", text: "Pune to Nashik Tempo Traveller On Rent", link: "Pune-to-Nashik-Tempo-Traveller-On-Rent" },
        { place: "/images/keyword/8.jpg", text: "Pune Darshan Tempo Traveller On Rent", link: "Pune-Darshan-Tempo-Traveller-On-Rent" },
        { place: "/images/keyword/9.jpg", text: "Mini Bus On Rent in Pune", link: "Mini-Bus-On-Rent-in-Pune" },
        { place: "/images/keyword/10.jpg", text: "13 Seater Tempo Traveller on Rent", link: "13-Seater-Tempo-Traveller-on-Rent" },
        { place: "/images/keyword/11.jpg", text: "17 Seater Tempo Traveller on Rent in Pune", link: "17-Seater-Tempo-Traveller-on-Rent-in-Pune" },
        { place: "/images/keyword/12.jpg", text: "20 Seater Bus on Rent in Pune", link: "20-Seater-Bus-on-Rent-in-Pune" },
        { place: "/images/keyword/13.jpg", text: "26 Seater Tempo Traveller on Rent in Pune", link: "26-Seater-Tempo-Traveller-on-Rent-in-Pune" },
        { place: "/images/keyword/14.jpg", text: "32 Seater Bus Rent in Pune", link: "32-Seater-Bus-Rent-in-Pune" },
        { place: "/images/keyword/15.jpg", text: "35 Seater Bus on Rent in Pune", link: "35-Seater-Bus-on-Rent-in-Pune" },
        { place: "/images/keyword/16.jpg", text: "45 Seater Bus on Rent in Pune", link: "45-Seater-Bus-on-Rent-in-Pune" },
        { place: "/images/keyword/17.jpg", text: "50 Seater Bus On Rent in Pune", link: "50-Seater-Bus-On-Rent-in-Pune" },
        { place: "/images/keyword/18.jpg", text: "Bus Rentals For School Trips in Pune", link: "Bus-Rentals-For-School-Trips-in-Pune" },
        { place: "/images/keyword/19.jpg", text: "Bus booking for wedding in Pune", link: "Bus-booking-for-wedding-in-Pune" },
        { place: "/images/keyword/20.jpg", text: "Bus Booking for Marriage", link: "Bus-Booking-for-Marriage" },
        { place: "/images/keyword/21.jpg", text: "Bus Service for Corporate Pune", link: "Bus-Service-for-Corporate-Pune" },
        { place: "/images/keyword/22.jpg", text: "Bus on Rent For Event in Pune", link: "Bus-on-Rent-For-Event-in-Pune" },
        { place: "/images/keyword/23.jpg", text: "Bus Hire for Outstation", link: "Bus-Hire-for-Outstation" },
        { place: "/images/keyword/24.jpg", text: "AC Bus On Rent in Pune", link: "AC-Bus-On-Rent-in-Pune" },
        { place: "/images/keyword/25.jpg", text: "Pune Bus Hire Rental Service", link: "Pune-Bus-Hire-Rental-Service" },
    ];













const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Urbania for Wedding Events in Pune",
  "image": "https://ruturajenterprises.com/assets/images/urbania-for-wedding-events-in-pune.webp",
  "description": "Urbania for Wedding Events in Pune from Ruturaj Enterprises is a spacious and comfortable transportation option for wedding families, guests, relatives and event groups who need organized travel between homes, hotels, venues, halls and other wedding locations. Urbania on Rent for Wedding Events Pune and Urbania Traveller for Wedding Pune can accommodate groups travelling together for ceremonies, receptions, pre-wedding functions and family gatherings. Urbania Hire for Wedding Guests Pune provides a practical option for transporting guests, while Luxury Urbania on Rent for Wedding Pune offers a premium travel arrangement for important family members and wedding guests. Different seating capacities can be arranged according to group requirements, including 13 Seater Urbania for Wedding Pune, 14 Seater Urbania for Wedding Pune, 17 Seater Urbania for Wedding Pune and 20 Seater Urbania for Wedding Pune. Urbania Booking for Wedding Pune and Urbania Van Rental for Wedding Pune are suitable for planned transportation throughout the wedding schedule. Urbania for Marriage Function Pune and Urbania for Marriage Ceremony Pune can support guest movement between venues, while Urbania for Wedding Guest Transportation Pune helps coordinate comfortable group transfers. Urbania Hire for Wedding Function Pune, Urbania for Wedding Party Pune and Urbania for Family Wedding Pune are suitable for celebrations involving larger groups. Urbania Traveller Booking for Wedding Pune and Urbania for Wedding Event Transportation Pune can be arranged for scheduled pickups and drops. Urbania on Rent for Marriage Pune and Luxury Urbania Traveller for Wedding Pune provide additional options for families seeking spacious, chauffeur-driven transportation for memorable wedding occasions.",
  "brand": {
    "@type": "Brand",
    "name": "Ruturaj Enterprises"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "8517"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "Starting From ₹12/Km",
    "availability": "https://schema.org/InStock",
    "url": "https://ruturajenterprises.com/urbania-for-wedding-events-in-pune"
  }
};



    return (
        <div>


<Helmet>
  <title>
    Urbania for Wedding Events in Pune | Luxury Traveller for Wedding Guests & Family Transportation | +91 9763381382
  </title>

  <meta
    name="description"
    content="Urbania for Wedding Events in Pune by Ruturaj Enterprises for 13, 14, 17 and 20 seater wedding guest transportation, marriage functions, family weddings, ceremonies and event travel."
  />

  <meta
    name="keywords"
    content="Urbania for Wedding Events in Pune, Urbania on Rent for Wedding Events Pune, Urbania Traveller for Wedding Pune, Urbania Hire for Wedding Guests Pune, Luxury Urbania on Rent for Wedding Pune, 13 Seater Urbania for Wedding Pune, 14 Seater Urbania for Wedding Pune, 17 Seater Urbania for Wedding Pune, 20 Seater Urbania for Wedding Pune, Urbania Booking for Wedding Pune, Urbania Van Rental for Wedding Pune, Urbania for Marriage Function Pune, Urbania for Wedding Guest Transportation Pune, Urbania for Marriage Ceremony Pune, Urbania Hire for Wedding Function Pune, Urbania for Wedding Party Pune, Urbania for Family Wedding Pune, Urbania Traveller Booking for Wedding Pune, Urbania for Wedding Event Transportation Pune, Urbania on Rent for Marriage Pune, Luxury Urbania Traveller for Wedding Pune, Urbania Wedding Guest Cab Pune, Urbania Wedding Transportation Pune, Urbania Wedding Rental Pune, Urbania Wedding Traveller Pune, Urbania for Reception Pune, Urbania for Marriage Reception Pune, Urbania for Wedding Guests Pune, Urbania for Family Function Pune, Urbania for Wedding Ceremony Pune, Urbania with Driver for Wedding Pune, AC Urbania for Wedding Pune, Urbania Wedding Guest Pickup Drop Pune, Urbania for Hotel to Wedding Venue Pune, Urbania for Wedding Group Travel Pune, Urbania for Wedding Outstation Pune, Urbania Wedding Event Vehicle Pune, Luxury Wedding Urbania Rental Pune, Pune Urbania wedding transportation service"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>



            <div
                className="ltn__breadcrumb-area ltn__breadcrumb-area-2 ltn__breadcrumb-color-white bg-overlay-theme-black-90 bg-image"
                style={{ backgroundImage: "url('/img/bg/9.jpg')" }}
            >
                <div className="container">
                    <div className="row">
                        <div className="col-lg-12">
                            <div className="ltn__breadcrumb-inner ltn__breadcrumb-inner-2 justify-content-between">
                                <div className="section-title-area ltn__section-title-2">
                                    <h1 className="section-title white-color">
                                        {cardData.keyword}
                                    </h1>
                                </div>


                            </div>
                        </div>
                    </div>
                </div>
            </div>






















            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/110.png' alt='img' className='img-fluid' />
                            <h3 className="py-1"
                                style={{
                                    color: '#FF681A', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >Ruturaj Enterprises: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="topPlaces">

                                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                                {cardData.topPlaces.map((place, index) => (
                                    <article key={index} className="placeCard borderr" tabIndex="0">
                                        <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                                        <div className="placeBody">
                                            <h4 className="placeTitle">{place.title}</h4>
                                            <p className="placeDesc">{place.description}</p>

                                        </div>

                                        <span className="placeArrow" aria-hidden>›</span>
                                    </article>
                                ))}
                            </div>


                            <div className="services-section">
                                {cardData.services.map((service, index) => (
                                    <div key={index} className="service-row">

                                        <div>
                                            <h4 className="service-title">{service.name}</h4>
                                            <p className="service-desc">{service.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>


                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            {/* <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable /> */}

                            <div id="why-choose-section" className="why-choose-section">


                                {/* Section Title */}
                                <h2 className="section-title text-white">
                                    Why Choose <span>Ruturaj Enterprises</span>
                                </h2>


                                {/* Cards */}
                                <div className="cards-grid">
                                    {cardData.whychoose.map((item, index) => (
                                        <div key={index} className="why-card">
                                            <div className="icon-circle">{index + 1}</div>
                                            <h4 className="card-heading">{item.WhyChooseheading}</h4>
                                            <p className="card-desc">{item.WhyChoosedescription}</p>
                                        </div>
                                    ))}
                                </div>
                            </div>



                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Ruturaj Enterprises </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                <FaqSection
                                                    title="Frequently Asked"
                                                    subtitle="Help & Info"
                                                    items={faqData}
                                                />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <TestimonialSectionKeyword
                                testimonials={testimonials}
                            />


                            <ContactShowcase keyword={cardData.keyword} />
                        </div>

                        <div className='col-12 col-md-4' >
                            <div className="routeList">
                                {Images.map((e, i) => {
                                    const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                                    const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                                    return (
                                        <a
                                            key={e.link || i}
                                            href={href}
                                            className="routeItem"
                                            aria-label={e.text}
                                            {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                                        >
                                            <div className="routeThumb">
                                                <img src={e.place} alt="" loading="lazy" />
                                            </div>

                                            <div className="routeMeta">
                                                <h6 className="routeTitle">{e.text}</h6>
                                                <span className="routeUnderline" />
                                            </div>

                                            <span className="routeArrow" aria-hidden>›</span>
                                        </a>
                                    );
                                })}
                            </div>




                            <div>
                                {/* <FleetHighway /> */}
                            </div>
                            <div className="pc-contact">
                                <h4 className="pc-title">Contact Information</h4>

                                <div className="pc-grid">
                                    {/* Phones */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-telephone-fill"></i>
                                            <span>Phone Numbers</span>
                                        </header>

                                        <div className="pc-list">
                                            <a href="tel:+919763381382" className="pc-call">+91 9763381382</a>
                                        </div>

                                        <div className="pc-list">
                                            <a href="tel:+919011051114" className="pc-call">+91 9011051114</a>
                                        </div>

                                        <div className="pc-list">
                                            <a href="tel:+919822697554" className="pc-call">+91 9822697554</a>
                                        </div>

                                        <div className="pc-cta">
                                            <a
                                                href="https://wa.me/919763381382"
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                className="pc-whats"
                                            >
                                                <i className="bi bi-whatsapp"></i> WhatsApp
                                            </a>
                                            <a href="tel:+919763381382" className="pc-primary">
                                                Call Now
                                            </a>
                                        </div>
                                    </section>

                                    {/* Email */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-envelope-fill"></i>
                                            <span>Email</span>
                                        </header>

                                        <a href="mailto:booking@ruturajenterprises.com" className="pc-email">
                                            booking@ruturajenterprises.com
                                        </a>
                                    </section>

                                    {/* Address */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-geo-alt-fill"></i>
                                            <span>Address</span>
                                        </header>

                                        <address className="pc-address">
                                            <strong>Ruturaj Enterprises</strong><br />

                                            Nandini Takle Nagar, Pune - Solapur Road Manjri Bk Hadapsar, Pune, Maharashtra 412307
                                        </address>
                                    </section>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Urbaniaforwedding;